import * as React from "react";
const SvgFiRrCircleS = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-circle-s_svg__a)">
      <path
        fill="#062147"
        d="M12.038.02c-6.617 0-12 5.382-12 12s5.383 12 12 12 12-5.383 12-12-5.383-12-12-12m0 22c-5.514 0-10-4.486-10-10s4.486-10 10-10 10 4.486 10 10-4.486 10-10 10m-3-12.815c0 .527.354.995.861 1.14l4.838 1.425a3.2 3.2 0 0 1 2.301 3.062 3.19 3.19 0 0 1-3.188 3.188h-3.312c-.979 0-2.618 0-3.395-1.553a1 1 0 0 1 1.79-.895c.188.38.585.447 1.604.447h3.312a1.19 1.19 0 0 0 .33-2.331l-4.835-1.424a3.195 3.195 0 0 1-2.307-3.061 3.19 3.19 0 0 1 3.186-3.185h3.314c.98 0 2.618 0 3.395 1.553a1 1 0 0 1-1.789.895c-.189-.38-.586-.447-1.605-.447h-3.314c-.653 0-1.186.532-1.186 1.186"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-circle-s_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCircleS;
